import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';
import { SNModal } from '@web-services/modal/snModal.interfaces';

@Component({
	selector: 'sn-quill-link-modal',
	template: require('./sn-quill-link-modal.html')
})
export class SnQuillLinkModal implements OnInit, SNModal {
	@Input() delta;

	enteredUrl: string;
	textToDisplay: string;
	hasChanged: boolean;
	disableLink: boolean;

	private lookedLinks = [
		'%contract_link%',
		'%invoice_link%',
		'%quote_link%',
		'%questionnaire_link%',
		'%galleries_link%'
	];

	constructor(
		private messageService: MessageService,
		private activeModal: NgbActiveModal,
		private modalService: SNModalService
	) {}

	ngOnInit(): void {
		this.successOpenModal(this.delta);
	}

	onDismiss(): void {
		this.modalService.setModalData(null);
	}

	insertLink(): void {
		if (this.checkLinkValidation()) {
			const data = {
				url: this.enteredUrl,
				text: this.textToDisplay,
				isEmail: this.isMail(this.enteredUrl)
			};
			this.modalService.setModalData(data);
		}
	}

	trackUrlInput(): void {
		if (!this.hasChanged) {
			this.textToDisplay = this.enteredUrl;
		}
	}

	trackTextInput(): void {
		this.textToDisplay.length
			? (this.hasChanged = true)
			: (this.hasChanged = false);
	}

	private successOpenModal(delta): void {
		const data = delta;

		if (data) {
			this.enteredUrl = data.url;
			this.textToDisplay = data.text;
			this.checkIfNotVariableUrl(this.enteredUrl);
		}

		if (data.text) {
			this.hasChanged = true;
		}
	}

	private checkLinkValidation() {
		if (!this.enteredUrl) {
			this.messageService.showToaster('e_0', 'generalValidation');
			return;
		}

		const isEmail = this.isMail(this.enteredUrl);

		if (this.isIncorrectUrl(this.enteredUrl)) {
			if ((isEmail && this.isIncorrectMail(this.enteredUrl)) || !isEmail) {
				this.messageService.showToaster('e_0', 'generalValidation');
				return;
			}
		}

		if (!this.textToDisplay.trim()) {
			this.textToDisplay = this.enteredUrl;
		}

		return true;
	}

	private isIncorrectUrl(url: string): boolean {
		if (this.disableLink) {
			return false;
		}

		if (url.startsWith('http://') && url.length > 7) {
			return false;
		}

		if (url.startsWith('https://') && url.length > 8) {
			return false;
		}

		return true;
	}

	private isMail = (email: string) => email.includes('@');

	private isIncorrectMail(email) {
		const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return !emailRegex.test(email);
	}

	private checkIfNotVariableUrl(url: string): void {
		if (url) {
			for (let i = 0, max = this.lookedLinks.length; i < max; i++) {
				if (url.includes(this.lookedLinks[i])) {
					this.disableLink = true;
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/sn-quill-editor/modals/sn-quill-link-modal/sn-quill-link-modal.ts